/**
 * @file utils.ts
 *
 * @fileoverview Contains Date widget utils functions.
 */

/**
 * Tries to construct Date from a given value.
 *
 * @param {string | undefined} fieldValue
 *  Form field value.
 * @returns {Date | null}
 *  Extracted date if the extraction was successful,
 *  null otherwise.
 */
export function extractInitialDate(fieldValue?: string): Date | null {
  let extractedDate: Date | null = null;

  if (fieldValue) {
    const parsedFieldDate = Date.parse(fieldValue);
    if (isNaN(parsedFieldDate) == false) {
      extractedDate = new Date(parsedFieldDate);
    }
  }

  return extractedDate;
}
